import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { PageLoadingAnimation } from "../../../components/loading/pageLoading";

const AuthCallback = () => {
  const { isAuthenticated, isLoading } = useKindeAuth();
  const navigate = useNavigate();
  const [checkCount, setCheckCount] = useState(0);

  useEffect(() => {
    // Wait for authentication to settle
    if (!isLoading) {
      if (isAuthenticated) {
        // Successfully authenticated, go to home
        navigate("/", { replace: true });
      } else if (checkCount < 10) {
        // Check again in a moment (give Kinde time to set auth state)
        setTimeout(() => {
          setCheckCount(prev => prev + 1);
        }, 300);
      } else {
        // After multiple checks, redirect to login
        navigate("/auth/login", { replace: true });
      }
    }
  }, [isAuthenticated, isLoading, checkCount, navigate]);

  return <PageLoadingAnimation isLoading={true} />;
};

export { AuthCallback };
